import Swiper from 'swiper';

export default function() {
  const testimonialsSlider = document.querySelectorAll('.testimonials');

  testimonialsSlider.forEach((block) => {
    const slider = block.querySelector('.swiper-container');

    const swiper = new Swiper(slider, {
      autoplay: {
        delay: 10000,
      },
      direction: 'horizontal',
      slidesPerView: 'auto',
      loop: true,
      speed: 1000,
      pagination: {
        el: block.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: 'true',
      },
      navigation: {
        nextEl: block.querySelector('.swiper-button-next'),
        prevEl: block.querySelector('.swiper-button-prev'),
      },
    });
  });
}
